import PropTypes from 'prop-types';

const Footer = () => (
  <div className="section footer wf-section">
    <div className="container-default">
      <div className="w-layout-grid grid-footer">
        <div className="container-footer">
          <a
            href="/"
            aria-current="page"
            className="brand-footer w-inline-block w--current"
          >
            <img
              src="/blog/webflow/images/yesware-by-vendasta-logo.svg"
              loading="eager"
              width="169"
              height="50"
              alt=""
            />
          </a>
          <p className="paragraph-small mg-bottom-24px">
            We&#x27;re on a mission to help you build lasting business
            relationships.
          </p>
          <div className="container-contact">
            <img
              src="/blog/webflow/images/address-icon.svg"
              loading="lazy"
              width="17"
              height="19"
              alt=""
              className="icon-contact"
            />
            <p className="paragraph-small">
                Vendasta Square Headquarters
‍410 - 22nd Street East, Floor 15 Saskatoon, SK, S7K 5T6, Canada
            </p>
          </div>
          <a
            href="mailto:support@yesware.com"
            className="container-contact link w-inline-block"
          >
            <img
              src="/blog/webflow/images/email-icon.svg"
              loading="lazy"
              width="21"
              height="16"
              alt=""
              className="icon-contact"
            />
            <p className="paragraph-small link">support@yesware.com</p>
          </a>
          <div className="container-social-media">
            <a
              rel="noopener noreferrer"
              href="https://www.facebook.com/yeswareco"
              target="_blank"
              className="link-social-media w-inline-block"
            >
              <img
                src="/blog/webflow/images/yesware-social-media-facebook.svg"
                loading="lazy"
                width="8"
                height="15"
                alt=""
              />
            </a>
            <a
              rel="noopener noreferrer"
              href="https://twitter.com/yesware"
              target="_blank"
              className="link-social-media w-inline-block"
            >
              <img
                src="/blog/webflow/images/yesware-social-media-twitter.svg"
                loading="lazy"
                width="16"
                height="13"
                alt=""
              />
            </a>
            <a
              rel="noopener noreferrer"
              href="https://www.linkedin.com/company/yesware-inc-/"
              target="_blank"
              className="link-social-media w-inline-block"
            >
              <img
                src="/blog/webflow/images/yesware-social-media-linkedin.svg"
                loading="lazy"
                width="15"
                height="14"
                alt=""
              />
            </a>
          </div>
          <div className="input-footer">Available on:</div>
          <a
            rel="noopener noreferrer"
            href="https://appsource.microsoft.com/en-us/product/office/WA104380259"
            target="_blank"
            className="button-download-footer w-inline-block"
          >
            <img
              src="/blog/webflow/images/download-microsoft.svg"
              loading="lazy"
              width="110"
              height="28"
              alt=""
            />
          </a>
          <a
            rel="noopener noreferrer"
            href="https://chrome.google.com/webstore/detail/gkjnkapjmjfpipfcccnjbjcbgdnahpjp"
            target="_blank"
            className="button-download-footer w-inline-block"
          >
            <img
              src="/blog/webflow/images/download-chrome.svg"
              loading="lazy"
              width="174"
              height="37"
              alt=""
            />
          </a>
        </div>
        <div className="container-footer">
          <div className="title-footer">Products</div>
          <a href="/feature" className="link-footer">
            Overview
          </a>
          <a href="/feature/email-tracking" className="link-footer">
            Email Tracking
          </a>
          <a href="/feature/attachment-tracking" className="link-footer">
            Attachment Tracking
          </a>
          <a href="/feature/campaigns" className="link-footer">
            Multi-Channel Campaigns
          </a>
          <a href="/feature/meeting-scheduler" className="link-footer">
            Meeting Scheduler
          </a>
          <a href="/feature/email-templates" className="link-footer">
            Email Templates
          </a>
          <a href="/feature/reporting-and-analytics" className="link-footer">
            Reporting &amp; Analytics
          </a>
          <a href="/feature/prospector" className="link-footer">
            Prospector
          </a>
          <a href="/feature/contacts" className="link-footer">
            Contacts
          </a>
          <a href="/feature/salesforce-integration" className="link-footer">
            Salesforce Integration
          </a>
          <a href="/feature/linkedin-sales-navigator" className="link-footer">
            LinkedIn Integration
          </a>
          <a href="/integrations" className="link-footer">
            Integrations
          </a>
          <a href="/platform/outlook" className="link-footer">
            Outlook Add-On
          </a>
          <a href="/platform/gmail" className="link-footer">
            Gmail Chrome Extension
          </a>
        </div>
        <div className="container-footer">
          <div className="title-footer">Solutions</div>
          <a href="/for-teams" className="link-footer">
            Teams
          </a>
          <a href="/use-cases#outbound-sales" className="link-footer">
            Outbound Sales
          </a>
          <a href="/use-cases#inbound-sales" className="link-footer">
            Inbound Sales
          </a>
          <a href="/use-cases#based-sales" className="link-footer">
            Account Based Sales
          </a>
          <a href="/personas#sales-reps" className="link-footer">
            Sales Reps
          </a>
          <a href="/personas#sales-managers" className="link-footer">
            Sales Managers
          </a>
          <a href="/personas#sales-ops" className="link-footer">
            Sales Operations
          </a>
          <a href="/personas#sales-executives" className="link-footer">
            Sales Executives
          </a>
          <a href="/personas#marketing" className="link-footer">
            Marketing
          </a>
          <a href="/personas#customer-success" className="link-footer">
            Customer Success
          </a>
          <a href="/personas#account-management" className="link-footer">
            Account Management
          </a>
          <a href="/personas#hr-recruiting" className="link-footer">
            HR &amp; Recruiting
          </a>
          <a href="/personas#entrepreneur" className="link-footer">
            Entrepreneurs
          </a>
          <a href="/personas#real-estate" className="link-footer">
            Real Estate
          </a>
        </div>
        <div className="container-footer">
          <div className="title-footer">Resources</div>
          <a href="/contact-sales" className="link-footer">
            Contact Sales
          </a>
          <a href="/plans-and-pricing" className="link-footer">
            Plans &amp; Pricing
          </a>
          <a href="https://help.yesware.com/hc/en-us" className="link-footer">
            Help Center
          </a>
          <a href="/yesware-u/" className="link-footer">
            Yesware University
          </a>
          <a href="/resources" className="link-footer">
            eBooks
          </a>
          <a href="/blog/" className="link-footer">
            Blog
          </a>
          <div className="title-footer mg-title-responsive">Guides</div>
          <a href="/blog/sales-prospecting/" className="link-footer">
            Sales Prospecting
          </a>
          <a href="/blog/cold-emailing/" className="link-footer">
            Cold Emailing
          </a>
          <a href="/blog/cold-calling-tips/" className="link-footer">
            Cold Calling
          </a>
          <a href="/blog/follow-up-email-guide/" className="link-footer">
            Follow-Up Email
          </a>
          <a
            href="/blog/definitive-guide-to-b2b-sales/"
            className="link-footer"
          >
            B2B Sales
          </a>
        </div>
        <div className="container-footer">
          <div className="title-footer">Trust</div>
          <a href="/yesware-difference" className="link-footer">
            Why Choose Yesware?
          </a>
          <a href="/customers" className="link-footer">
            Customer Stories
          </a>
          <div className="title-footer mg-title-responsive">Company</div>
          <a href="/company" className="link-footer">
            About Us
          </a>
          <a
            href="https://www.vendasta.com/company/careers/"
            target="_blank"
            className="link-footer"
            rel="noreferrer"
          >
            Careers
          </a>
          <a href="/sign-up" className="link-footer">
            Try Free
          </a>
          <a href="/user/sign-in" className="link-footer">
            Sign In
          </a>
        </div>
      </div>
      <div className="divider-section"></div>
      <div className="w-layout-grid grid-copyright">
        <div className="container-copyright-left">
          <div className="copyright-content">
            © Vendasta 2023 |{' '}
            <a href="/security/" className="link-copyright">
              Security
            </a>{' '}
            |{' '}
            <a href="/gdpr/" className="link-copyright">
              GDPR
            </a>{' '}
            |{' '}
            <a href="/privacy/" className="link-copyright">
              Privacy
            </a>{' '}
            |{' '}
            <a href="/terms/" className="link-copyright">
              Terms
            </a>
          </div>
        </div>
        <div className="container-copyright-right">
          <img
            src="/blog/webflow/images/yesware-miscrosoft-partner.svg"
            loading="lazy"
            width="121"
            height="38"
            alt=""
            className="partner-image"
          />
          <img
            src="/blog/webflow/images/yesware-google-partner.svg"
            loading="lazy"
            width="133"
            height="35"
            alt=""
            className="partner-image"
          />
          <img
            src="/blog/webflow/images/yesware-salesforce-partner.png"
            loading="lazy"
            width="125"
            height="42"
            alt=""
            className="partner-image salesforce"
          />
        </div>
      </div>
    </div>
  </div>
);

const Webflow = ({ children }) => (
  <>
    <>{children}</>
    <div className="webflow">
      <Footer />
    </div>
  </>
);

Webflow.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Webflow;
